<script>
    import {onMount} from "svelte";

    export let sliderSlides = [];
    export let sliderSpeedMs = 7000;
    let slideIndex = 1;

    function nextSlide() {
        if (slideIndex == sliderSlides.length) {
            slideIndex = 1;
        } else {
            slideIndex++;
        }
    }

    function prevSlide() {
        if (slideIndex === 1) {
            slideIndex = sliderSlides.length;
        } else {
            slideIndex--;
        }
    }

    onMount(async () => {

        setInterval(function () {
            nextSlide();
        }, sliderSpeedMs);
    });
</script>

<div class="sliderContainer">
    <div>

        {#each sliderSlides as s}
            {#if slideIndex == s.id}
                <div class="slider-img" style="background-image: url('{s.src}');"></div>
                <div class="sliderContentContainer">
                    {#if s.header}
                        <div class="sliderHeader headerText">{s.header}</div>
                    {/if}
                    {#if s.content}
                        {#if s.contentType === "Button"}
                            <div class="sliderContentButton">
                                <div class="hero-img-body"><a href="{s.contentUrl}">{s.content}</a></div>
                            </div>
                        {:else}
                            <div class="sliderContent contentText">{s.content}</div>
                        {/if}
                    {/if}
                </div>
            {/if}
        {/each}

    </div>
    <ol class="carousel-indicators">
        {#each sliderSlides as s}
            {#if slideIndex == s.id}
                <li class="active"></li>
            {:else}
                <li class=""></li>
            {/if}
        {/each}
    </ol>
</div>

<style>
    .sliderContainer {
        height: 830px;
        position: relative;
    }

    .slider-img {
        width: 100%;
        height: 830px;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .sliderContentContainer {
        position: absolute;
        top: 100px;
        width: 100%;
    }
    @media all and (max-width: 900px) {
        .headerText {
            font-size: 35px;
        }
    }
    @media all and (min-width: 901px) {
        .headerText {
            font-size: 45px;
        }
    }
    .sliderHeader {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        text-transform: uppercase;
        text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        color: white;
    }
    @media all and (max-width: 900px) {
        .contentText {
            font-size: 25px;
        }
    }
    @media all and (min-width: 901px) {
        .contentText {
            font-size: 35px;
        }
    }
    .sliderContent {
        color: white;
        text-align: center;
    }

</style>